<div class="main-content">

  <!-- ===== HEADER ===== -->
  <div class="header-section">
    <div class="wm-heading">
      <div class="wm-heading-icon wm-heading-icon--green">
        <i class="fas fa-undo"></i>
      </div>
      <div>
        <h1 class="main-title">Elenco Resi</h1>
        <p class="main-subtitle">Consultazione dei resi affidati: stato di avanzamento, tempi di consegna e dettaglio degli eventi</p>
      </div>
    </div>

    <!-- Strumentario -->
    <div class="toolbox-container">
        <div class="toolbox-heading">
          <div class="toolbox-heading-icon">
            <i class="fas fa-tools"></i>
          </div>
          <div class="toolbox-heading-text">
            <span class="toolbox-title">Strumentario</span>
            <small class="toolbox-subtitle">Strumenti rapidi</small>
          </div>
        </div>
        <div class="toolbox-divider"></div>
        <div class="toolbox-buttons">

          <!-- Tour guidato -->
          <button type="button" class="toolbox-btn toolbox-btn--blue" (click)="startTour()"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  [title]="'TOUR.START_TOUR' | translate">
            <i class="fas fa-route"></i>
          </button>

          <!-- Aggiorna dati -->
          <button type="button" class="toolbox-btn toolbox-btn--green" (click)="refreshData()"
                  [disabled]="isLoading"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  title="Aggiorna i dati (ri-esegue la ricerca con i filtri correnti)">
            <i class="fas fa-sync-alt" [class.fa-spin]="isLoading"></i>
          </button>

          <!-- Comprimi/Espandi filtri -->
          <button type="button" class="toolbox-btn toolbox-btn--purple" (click)="toggleFiltersSection()"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  title="Comprimi/Espandi la sezione filtri">
            <i class="fas" [ngClass]="showFilters ? 'fa-compress-alt' : 'fa-expand-alt'"></i>
          </button>

          <!-- Densità tabella -->
          <button type="button" class="toolbox-btn toolbox-btn--orange" [class.active]="isCompactTable"
                  (click)="toggleCompactTable()"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  title="Attiva/Disattiva la vista compatta della tabella">
            <i class="fas fa-grip-lines"></i>
          </button>

        </div>
      </div>
  </div>

  <!-- ===== SECTION 1: FILTRI E AZIONI ===== -->
  <div id="filters-section" class="card mb-4">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-filter header-icon"></i>
          <h3>Filtri e Azioni</h3>
        </div>
        <div class="d-flex align-items-center gap-2">
          <span class="badge bg-primary-subtle text-primary filters-active-badge" *ngIf="hasActiveFilters()">
            <i class="fas fa-sliders-h me-1"></i> Filtri attivi
          </span>
          <button type="button" class="btn btn-sm btn-outline-secondary"
                  (click)="toggleFiltersSection()"
                  [title]="showFilters ? 'Comprimi' : 'Espandi'">
            <i class="fas" [ngClass]="showFilters ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="card-body" *ngIf="showFilters">

      <!-- Filtri di selezione: vanno a capo da soli, il numero di campi visibili
           cambia quando cliente o marchio sono unici e la loro select è nascosta -->
      <div class="row g-3">
        <div class="col-md-3" *ngIf="filteredClients.length > 1">
          <label class="form-label">Clienti</label>
          <app-searchable-select
                  [(ngModel)]="selectedClients"
                  [options]="clientSelectOptions"
                  [multiple]="true"
                  allOptionLabel="Tutti i clienti"
                  icon="fas fa-users"
                  searchPlaceholder="Cerca cliente..."
                  (valueChange)="onClientsChange()">
          </app-searchable-select>
        </div>

        <div class="col-md-3">
          <label class="form-label">Marchi</label>
          <app-searchable-select
                  [(ngModel)]="selectedBrands"
                  [options]="brandSelectOptions"
                  [multiple]="true"
                  [disabled]="brandSelectOptions.length <= 1"
                  allOptionLabel="Tutti i marchi"
                  icon="fas fa-tag"
                  searchPlaceholder="Cerca marchio...">
          </app-searchable-select>
        </div>

        <div class="col-md-3">
          <label class="form-label">Gruppi Tipologie</label>
          <app-searchable-select
                  [(ngModel)]="palletTypesGroupCode"
                  [options]="palletTypesGroupOptions"
                  allOptionLabel="Tutte le tipologie"
                  icon="fas fa-layer-group"
                  searchPlaceholder="Cerca gruppo..."
                  (valueChange)="onGroupChange()">
          </app-searchable-select>
        </div>

        <div class="col-md-3">
          <label class="form-label">Tipologie Specifiche</label>
          <app-searchable-select
                  [(ngModel)]="palletTypesCode"
                  [options]="palletTypesOptions"
                  [disabled]="!palletTypesGroupCode"
                  allOptionLabel="Tutte"
                  icon="fas fa-tags"
                  searchPlaceholder="Cerca tipologia...">
          </app-searchable-select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Codice Dealer</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-store filter-icon"></i>
            <input type="text" class="filter-input" maxlength="99"
                   [(ngModel)]="searchDealerCode" (keyup.enter)="onSearchEnter()"
                   placeholder="Cerca per codice dealer...">
          </div>
        </div>

        <!-- Select Dealer nascosto: le opzioni derivano dai soli dati caricati,
             per filtrare resta il campo "Codice Dealer"
        <div class="col-md-3">
          <label class="form-label">Dealer</label>
          <app-searchable-select
                  [(ngModel)]="selectedDealerCode"
                  [options]="dealerSelectOptions"
                  allOptionLabel="Tutti i dealer"
                  icon="fas fa-store"
                  searchPlaceholder="Cerca dealer...">
          </app-searchable-select>
        </div>
        -->


        <div class="col-md-3">
          <label class="form-label">Codice Reso</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-box-open filter-icon"></i>
            <input type="text" class="filter-input" maxlength="99"
                   [(ngModel)]="searchPalletCode" (keyup.enter)="onSearchEnter()"
                   placeholder="Cerca per codice reso...">
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Codice Bolla</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-barcode filter-icon"></i>
            <input type="text" class="filter-input" maxlength="99"
                   [(ngModel)]="searchWaybillCode" (keyup.enter)="onSearchEnter()"
                   placeholder="Cerca per codice bolla...">
          </div>
        </div>
        <div class="col-md-3">
          <label class="form-label">Puntualità</label>
          <app-searchable-select
                  [(ngModel)]="onTimeStatus"
                  [options]="onTimeOptions"
                  allOptionLabel="In orario e non"
                  icon="fas fa-clock"
                  searchPlaceholder="Cerca...">
          </app-searchable-select>
        </div>

        <div class="col-md-3">
          <label class="form-label">Stati Correnti</label>
          <app-searchable-select
                  [(ngModel)]="selectedCurrentStatus"
                  [options]="currentStatusSelectOptions"
                  [multiple]="true"
                  allOptionLabel="Tutti gli stati"
                  icon="fas fa-list-check"
                  searchPlaceholder="Cerca stato...">
          </app-searchable-select>
        </div>

        <div class="col-md-3">
          <label class="form-label">Vettore</label>
          <app-searchable-select
                  [(ngModel)]="selectedCarrierCode"
                  [options]="carrierSelectOptions"
                  allOptionLabel="Tutti i vettori"
                  icon="fas fa-truck-loading"
                  searchPlaceholder="Cerca vettore...">
          </app-searchable-select>
        </div>

        <div class="col-md-3">
          <label class="form-label">Piattaforma</label>
          <app-searchable-select
                  [(ngModel)]="warehouseCode"
                  [options]="warehouseSelectOptions"
                  allOptionLabel="Tutte le piattaforme"
                  icon="fas fa-warehouse"
                  searchPlaceholder="Cerca piattaforma...">
          </app-searchable-select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Regione</label>
          <app-searchable-select
                  [(ngModel)]="selectedRegionCode"
                  [options]="regionSelectOptions"
                  allOptionLabel="Tutte le regioni"
                  icon="fas fa-map"
                  searchPlaceholder="Cerca regione...">
          </app-searchable-select>
        </div>

      </div>

      <!-- Riga 5: i quattro filtri data, con calendario e navigazione giorno -->
      <div id="returns-date-filters" class="row g-3 mt-0">
        <div class="col-md-3">
          <label class="form-label">Affido Da</label>
          <div class="filter-input-wrapper" [class.rt-field-error]="isDateFieldInError('dateStart')">
            <i class="fas fa-calendar-plus filter-icon"></i>
            <input #dateStartInput
                   type="text"
                   class="filter-input"
                   [value]="getFormattedDate('dateStart')"
                   (click)="openDatePicker('dateStart')"
                   (focus)="openDatePicker('dateStart')"
                   readonly
                   placeholder="Seleziona data da">
            <div class="date-navigation-controls">
              <div class="date-nav-separator"></div>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('dateStart', -1)"
                      title="Giorno precedente">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="setDateFieldToday('dateStart')" title="Oggi">
                <i class="fas fa-calendar-day"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('dateStart', 1)"
                      title="Giorno successivo">
                <i class="fas fa-chevron-right"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="clearDateField('dateStart')" title="Cancella data">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Affido A</label>
          <div class="filter-input-wrapper" [class.rt-field-error]="isDateFieldInError('dateEnd')">
            <i class="fas fa-calendar-minus filter-icon"></i>
            <input #dateEndInput
                   type="text"
                   class="filter-input"
                   [value]="getFormattedDate('dateEnd')"
                   (click)="openDatePicker('dateEnd')"
                   (focus)="openDatePicker('dateEnd')"
                   readonly
                   placeholder="Seleziona data a">
            <div class="date-navigation-controls">
              <div class="date-nav-separator"></div>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('dateEnd', -1)"
                      title="Giorno precedente">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="setDateFieldToday('dateEnd')" title="Oggi">
                <i class="fas fa-calendar-day"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('dateEnd', 1)"
                      title="Giorno successivo">
                <i class="fas fa-chevron-right"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="clearDateField('dateEnd')" title="Cancella data">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Consegna Da</label>
          <div class="filter-input-wrapper" [class.rt-field-error]="isDateFieldInError('dateDeliveryStart')">
            <i class="fas fa-calendar-plus filter-icon"></i>
            <input #dateDeliveryStartInput
                   type="text"
                   class="filter-input"
                   [value]="getFormattedDate('dateDeliveryStart')"
                   (click)="openDatePicker('dateDeliveryStart')"
                   (focus)="openDatePicker('dateDeliveryStart')"
                   readonly
                   placeholder="Seleziona data da">
            <div class="date-navigation-controls">
              <div class="date-nav-separator"></div>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('dateDeliveryStart', -1)"
                      title="Giorno precedente">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="setDateFieldToday('dateDeliveryStart')" title="Oggi">
                <i class="fas fa-calendar-day"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('dateDeliveryStart', 1)"
                      title="Giorno successivo">
                <i class="fas fa-chevron-right"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="clearDateField('dateDeliveryStart')"
                      title="Cancella data">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Consegna A</label>
          <div class="filter-input-wrapper" [class.rt-field-error]="isDateFieldInError('dateDeliveryEnd')">
            <i class="fas fa-calendar-minus filter-icon"></i>
            <input #dateDeliveryEndInput
                   type="text"
                   class="filter-input"
                   [value]="getFormattedDate('dateDeliveryEnd')"
                   (click)="openDatePicker('dateDeliveryEnd')"
                   (focus)="openDatePicker('dateDeliveryEnd')"
                   readonly
                   placeholder="Seleziona data a">
            <div class="date-navigation-controls">
              <div class="date-nav-separator"></div>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('dateDeliveryEnd', -1)"
                      title="Giorno precedente">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="setDateFieldToday('dateDeliveryEnd')" title="Oggi">
                <i class="fas fa-calendar-day"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="shiftDateField('dateDeliveryEnd', 1)"
                      title="Giorno successivo">
                <i class="fas fa-chevron-right"></i>
              </button>
              <button type="button" class="date-nav-btn" (click)="clearDateField('dateDeliveryEnd')"
                      title="Cancella data">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Chiusura manuale: toggle sullo stile di "Colli Danneggiati" di /shipment-management.
             Spento = tutti i resi, acceso = solo quelli con data di consegna forzata -->
        <div class="col-md-3">
          <label class="form-label">Chiusura Manuale</label>
          <div class="filter-input-wrapper rt-forced-filter-wrapper">
            <i class="fas fa-hand filter-icon"></i>
            <span class="rt-forced-filter-text" [class.active]="filterForcedDelivery">
              {{ filterForcedDelivery ? 'Solo chiusi manualmente' : 'Tutti i resi' }}
            </span>
            <button type="button" class="rt-forced-filter-switch"
                    role="switch" [attr.aria-checked]="filterForcedDelivery"
                    [class.active]="filterForcedDelivery"
                    (click)="setFilterForcedDelivery(!filterForcedDelivery)"
                    [title]="filterForcedDelivery ? 'Solo chiusi manualmente' : 'Tutti i resi'">
              <span class="rt-forced-filter-switch-knob">
                <i class="fas" [ngClass]="filterForcedDelivery ? 'fa-hand' : 'fa-truck'"></i>
              </span>
            </button>
          </div>
        </div>
      </div>

      <!-- Errore sugli intervalli di date -->
      <div class="row mt-3" *ngIf="dateError">
        <div class="col-12">
          <div class="rt-date-error" role="alert">
            <div class="rt-date-error-icon">
              <i class="fas fa-calendar-xmark"></i>
            </div>
            <div class="rt-date-error-body">
              <div class="rt-date-error-title">Controlla le date</div>
              <div class="rt-date-error-text">{{ dateError }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Azioni -->
      <div class="row mt-3">
        <div class="col-12">
          <div id="returns-filter-actions" class="d-flex justify-content-end gap-2">
            <button type="button" class="btn btn-outline-secondary btn-sm"
                    (click)="resetFilters()" title="Azzera filtri">
              <i class="fas fa-undo me-1"></i> Azzera filtri
            </button>
            <button type="button" class="btn btn-primary btn-sm"
                    (click)="applyFilters()" [disabled]="isLoading" title="Applica filtri">
              <i class="fas" [ngClass]="isLoading ? 'fa-spinner fa-spin me-1' : 'fa-search me-1'"></i>
              Applica filtri
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ===== SECTION 2: RESI ===== -->
  <div id="returns-section" class="card">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <div class="header-title">
          <i class="fas fa-box-open header-icon"></i>
          <h3>Resi</h3>
        </div>

        <div class="controls-container">
          <!-- Esportazioni -->
          <button type="button" id="returns-export-excel" class="header-action-btn me-1"
                  (click)="exportParcelsToExcel()"
                  [disabled]="totalCount === 0"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  title="Scarica Excel">
            <i class="fas fa-file-excel text-success"></i>
          </button>

          <button type="button" id="returns-export-details" class="header-action-btn me-1"
                  (click)="exportParcelsDetailsToExcel()"
                  [disabled]="totalCount === 0"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  title="Scarica Excel Dettaglio">
            <i class="fas fa-file-excel text-success"></i>
            <i class="fas fa-list-ul ms-1 text-muted"></i>
          </button>

          <!-- Excel di chiusura: apre il popup di caricamento -->
          <button type="button" id="returns-closure-excel" class="header-action-btn header-action-btn--closure me-1"
                  (click)="openCloseReturnsPopup()"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  title="Carica Excel di Chiusura dei Resi">
            <i class="fas fa-file-excel"></i>
            <i class="fas fa-arrow-up ms-1"></i>
          </button>

          <!-- Chiusura multipla: apre il popup con i resi selezionati in tabella -->
          <button type="button" id="returns-close-selected" class="header-action-btn header-action-btn--closure me-1"
                  (click)="openCloseSelectedPopup()"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  title="Chiudi i resi selezionati con la stessa data di consegna">
            <i class="fas fa-calendar-check"></i>
            <span class="rt-selected-badge" *ngIf="selectedCount > 0">{{ selectedCount }}</span>
          </button>

          <!-- Resi per vettore: apre il popup con intervallo di date e vettori -->
          <button type="button" id="returns-platform-excel" class="header-action-btn header-action-btn--platform me-1"
                  (click)="openPlatformExcelPopup()"
                  data-bs-toggle="tooltip"
                  data-bs-placement="bottom"
                  title="Resi per vettore">
            <i class="fas fa-file-excel"></i>
            <i class="fas fa-truck ms-1"></i>
          </button>

          <!-- Gestione colonne visibili -->
          <div class="toolbox-dropdown-wrapper me-1">
            <button type="button" class="header-action-btn"
                    [class.active]="isColumnsDropdownOpen || hiddenColumns.size > 0"
                    (click)="toggleColumnsDropdown()"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="Gestisci le colonne visibili della tabella">
              <i class="fas fa-columns"></i>
            </button>
            <div class="toolbox-dropdown-backdrop" *ngIf="isColumnsDropdownOpen"
                 (click)="isColumnsDropdownOpen = false"></div>
            <div class="toolbox-columns-dropdown" *ngIf="isColumnsDropdownOpen">
              <div class="toolbox-columns-header">
                <span>Colonne visibili</span>
                <button type="button" class="btn btn-sm btn-link p-0"
                        (click)="resetColumnVisibility()"
                        [disabled]="!hasCustomColumns">
                  Ripristina
                </button>
              </div>
              <div class="toolbox-column-option"
                   *ngFor="let col of orderedColumnOptions; let i = index; let last = last">
                <label class="toolbox-column-check">
                  <input type="checkbox" class="form-check-input me-2"
                         [checked]="isColumnVisible(col.key)"
                         (change)="toggleColumnVisibility(col.key)">
                  <span>{{ col.label }}</span>
                </label>
                <span class="toolbox-column-move">
                  <button type="button" title="Sposta su"
                          (click)="moveColumn(col.key, -1)" [disabled]="i === 0">
                    <i class="fas fa-chevron-up"></i>
                  </button>
                  <button type="button" title="Sposta giù"
                          (click)="moveColumn(col.key, 1)" [disabled]="last">
                    <i class="fas fa-chevron-down"></i>
                  </button>
                </span>
              </div>
            </div>
          </div>

          <!-- Elementi per pagina -->
          <div class="btn-group btn-group-sm pagination-selector" role="group" aria-label="Elementi per pagina">
            <button type="button" class="btn"
                    *ngFor="let size of pageSizeOptions"
                    [ngClass]="itemsPerPage === size ? 'btn-secondary' : 'btn-outline-secondary'"
                    (click)="setItemsPerPage(size)"
                    [title]="size + ' elementi per pagina'">
              {{ size }}
            </button>
          </div>

          <!-- Conteggio risultati -->
          <div class="counter-display">
            <span class="badge bg-light text-muted" title="Resi trovati">
              <i class="fas fa-box-open me-1"></i>
              {{ totalCount | number }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="card-body p-0">

      <!-- Nessun risultato -->
      <div class="returns-empty-state" *ngIf="!isLoading && oprPallets.length === 0">
        <i class="fas fa-inbox fa-2x mb-3 text-muted"></i>
        <h5>Nessun reso trovato</h5>
        <p class="mb-0 text-muted">Modifica i filtri e riprova.</p>
      </div>

      <!-- Tabella resi -->
      <div class="table-responsive" [class.table-compact]="isCompactTable" *ngIf="!isLoading && oprPallets.length > 0">
        <table class="table rt-table mb-0">
          <thead>
            <tr>
              <!-- Intestazioni generate dall'ordine corrente delle colonne:
                   trascinabili per riordinarle, click per l'ordinamento righe -->
              <th *ngFor="let col of visibleColumns"
                  [class.sortable-th]="!!col.sortKey"
                  [class.text-center]="col.key === 'palletOnTime' || col.key === 'print' || col.key === 'select'"
                  [class.rt-th-dragging]="draggedColumnKey === col.key"
                  [class.rt-th-drag-over]="dragOverColumnKey === col.key && draggedColumnKey !== col.key"
                  draggable="true"
                  (dragstart)="onColumnDragStart(col.key)"
                  (dragover)="onColumnDragOver($event, col.key)"
                  (drop)="onColumnDrop(col.key)"
                  (dragend)="onColumnDragEnd()"
                  (click)="col.sortKey ? setSort(col.sortKey) : null"
                  [title]="col.sortKey ? 'Clicca per ordinare, trascina per spostare la colonna' : 'Trascina per spostare la colonna'">
                <!-- Colonna di selezione: checkbox che seleziona tutti i resi chiudibili della pagina -->
                <ng-container *ngIf="col.key === 'select'; else colLabel">
                  <input type="checkbox" class="form-check-input rt-select-check"
                         [checked]="areAllOnPageSelected"
                         [indeterminate]="isPageSelectionPartial"
                         [disabled]="closablePalletsOnPage.length === 0"
                         (click)="toggleSelectAllOnPage($event)"
                         title="Seleziona tutti i resi chiudibili della pagina">
                </ng-container>
                <ng-template #colLabel>{{ col.label }}</ng-template>
                <i *ngIf="col.sortKey" class="bi ms-1" [ngClass]="{
                  'bi-arrow-down': sortState.active === col.sortKey && sortState.direction === 'desc',
                  'bi-arrow-up': sortState.active === col.sortKey && sortState.direction === 'asc',
                  'bi-arrow-down-up': sortState.active !== col.sortKey || sortState.direction === ''
                }"></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <!-- La ricerca è paginata dal backend: filteredOprPallets contiene
                 già la sola pagina corrente, nessun ritaglio lato client -->
            <ng-container *ngFor="let p of filteredOprPallets">
              <tr class="rt-row" [class.expanded]="openedPalletId === p.palletId"
                  (click)="toggleComPallets(p)" title="Mostra il dettaglio degli stati">
                <!-- Celle nello stesso ordine delle intestazioni (visibleColumns) -->
                <ng-container *ngFor="let col of visibleColumns">
                  <ng-container [ngSwitch]="col.key">
                    <!-- Selezione per la chiusura multipla: solo i resi non ancora consegnati -->
                    <td class="text-center" *ngSwitchCase="'select'">
                      <input type="checkbox" class="form-check-input rt-select-check"
                             *ngIf="isPalletClosable(p)"
                             [checked]="isPalletSelected(p)"
                             (click)="togglePalletSelection(p, $event)"
                             title="Seleziona per la chiusura multipla">
                    </td>
                    <td class="text-center" *ngSwitchCase="'print'">
                      <button type="button" class="btn btn-sm btn-outline-primary rt-print-btn"
                              title="Stampa label / bolla del reso"
                              (click)="openReturnPrintPopup(p, $event)">
                        <i class="fas fa-print"></i>
                      </button>
                    </td>
                    <td *ngSwitchCase="'palletClientName'">{{ p.palletClientName }}<ng-container *ngTemplateOutlet="copyBtn; context: { p: p, col: col }"></ng-container></td>
                    <td *ngSwitchCase="'palletBrandName'">{{ p.palletBrandName }}<ng-container *ngTemplateOutlet="copyBtn; context: { p: p, col: col }"></ng-container></td>
                    <td class="rt-code" *ngSwitchCase="'palletCode'">{{ p.palletCode }}<ng-container *ngTemplateOutlet="copyBtn; context: { p: p, col: col }"></ng-container></td>
                    <td *ngSwitchCase="'palletTypesGroupName'">{{ p.palletTypesGroupName }}<ng-container *ngTemplateOutlet="copyBtn; context: { p: p, col: col }"></ng-container></td>
                    <td class="rt-code" *ngSwitchCase="'palletWaybillCode'">{{ p.palletWaybillCode }}<ng-container *ngTemplateOutlet="copyBtn; context: { p: p, col: col }"></ng-container></td>
                    <td class="rt-date" *ngSwitchCase="'palletDate'">{{ p.palletDate | date: 'dd/MM/yyyy HH:mm' }}<ng-container *ngTemplateOutlet="copyBtn; context: { p: p, col: col }"></ng-container></td>
                    <td *ngSwitchCase="'palletDeliveryType'">{{ p.palletDeliveryType }}<ng-container *ngTemplateOutlet="copyBtn; context: { p: p, col: col }"></ng-container></td>
                    <td class="rt-code" *ngSwitchCase="'palletDealerCode'">{{ p.palletDealerCode }}<ng-container *ngTemplateOutlet="copyBtn; context: { p: p, col: col }"></ng-container></td>
                    <td class="rt-strong" *ngSwitchCase="'dealerName'">{{ p.dealerName }}<ng-container *ngTemplateOutlet="copyBtn; context: { p: p, col: col }"></ng-container></td>
                    <td *ngSwitchCase="'dealerAddress'">{{ p.dealerOperatingAddressStreet }} - {{ p.dealerOperatingAddressCity }}<ng-container *ngTemplateOutlet="copyBtn; context: { p: p, col: col }"></ng-container></td>
                    <!-- Data Consegna: se il reso non è ancora consegnato la cella ospita
                         il bottone di chiusura manuale al posto della data -->
                    <td class="rt-date" *ngSwitchCase="'palletActualDeliveryDate'">
                      <ng-container *ngIf="p.palletStatus === 'DELIVERED'; else closeManualBtn">
                        <!-- Badge arancione con la mano: data di consegna impostata manualmente (chiusura forzata) -->
                        <span *ngIf="p.palletDeliveryDateIsForced === 'Y'"
                              class="rt-forced-badge"
                              title="Data di consegna impostata manualmente">
                          <i class="fas fa-hand"></i>
                        </span>
                        {{ p.palletActualDeliveryDate | date: 'dd/MM/yyyy HH:mm' }}<ng-container *ngTemplateOutlet="copyBtn; context: { p: p, col: col }"></ng-container>
                      </ng-container>
                      <ng-template #closeManualBtn>
                        <button type="button" class="btn btn-sm btn-outline-warning rt-close-manual-btn"
                                title="Chiudi manualmente il reso impostando la data di consegna"
                                (click)="openCloseManualPopup(p, $event)">
                          <i class="fas fa-calendar-check me-1"></i>Chiudi
                        </button>
                      </ng-template>
                    </td>
                    <td class="rt-date" *ngSwitchCase="'palletEstimatedDeliveryDate'">{{ p.palletEstimatedDeliveryDate | date: 'dd/MM/yyyy HH:mm' }}<ng-container *ngTemplateOutlet="copyBtn; context: { p: p, col: col }"></ng-container></td>
                    <td class="text-center" *ngSwitchCase="'palletOnTime'">
                      <ng-container [ngSwitch]="p.palletOnTime">
                        <span class="is-valid" *ngSwitchCase="'ON_TIME'">Si</span>
                        <span class="is-invalid" *ngSwitchCase="'NOT_ON_TIME'">No</span>
                        <span *ngSwitchDefault>{{ p.palletOnTime }}</span>
                      </ng-container>
                      <ng-container *ngTemplateOutlet="copyBtn; context: { p: p, col: col }"></ng-container>
                    </td>
                    <td *ngSwitchCase="'palletCurrentStatus'">{{ p.palletCurrentStatus }}<ng-container *ngTemplateOutlet="copyBtn; context: { p: p, col: col }"></ng-container></td>
                    <td *ngSwitchCase="'warehouse'">{{ getFirstWarehouseName(p) }}<ng-container *ngTemplateOutlet="copyBtn; context: { p: p, col: col }"></ng-container></td>
                    <td *ngSwitchCase="'carrier'">{{ getFirstCarrierName(p) }}<ng-container *ngTemplateOutlet="copyBtn; context: { p: p, col: col }"></ng-container></td>
                    <td *ngSwitchCase="'regionName'">{{ p.regionName }}<ng-container *ngTemplateOutlet="copyBtn; context: { p: p, col: col }"></ng-container></td>
                    <td class="rt-code" *ngSwitchCase="'palletShipmentCode'">{{ p.palletShipmentCode }}<ng-container *ngTemplateOutlet="copyBtn; context: { p: p, col: col }"></ng-container></td>
                  </ng-container>
                </ng-container>
              </tr>

              <!-- Dettaglio degli stati (comPallets) -->
              <tr *ngIf="openedPalletId === p.palletId" class="rt-detail-row">
                <td [attr.colspan]="detailColspan" class="p-0">
                  <div class="rt-detail p-3">
                    <!-- Reso senza stati registrati: senza questo avviso il
                         pannello aperto risulterebbe vuoto senza spiegazione -->
                    <div class="rt-no-states" *ngIf="getFilteredPallets(p).length === 0">
                      <i class="fa-solid fa-triangle-exclamation me-2"></i>
                      Nessuno stato presente per questo reso.
                    </div>

                    <div class="timeline-wrapper d-flex flex-column"
                         *ngIf="getFilteredPallets(p).length > 0">

                      <ng-container *ngFor="let c of getFilteredPallets(p); let i = index">
                        <ng-container *ngIf="c.palletComplementaryValueNumber != null && c.palletComplementaryValueNumber !== ''">
                          <div class="step-row d-flex align-items-center p-2 bg-white shadow-sm flex-wrap flex-md-nowrap">

                            <!-- Icona + Step -->
                            <div class="d-flex align-items-center me-3 mb-2 mb-md-0 step-label">
                              <ng-container [ngSwitch]="c.palletComplementaryValueNumber">
                                <ng-container *ngSwitchCase="0">
                                  <i class="fa-solid fa-clock text-orange fs-6 me-2"></i>
                                  <span class="badge badge-orange me-2">0</span>
                                  <strong>Pianificato</strong>
                                </ng-container>

                                <ng-container *ngSwitchCase="1">
                                  <i class="fa-solid fa-handshake text-green fs-6 me-2"></i>
                                  <span class="badge badge-green me-2">1</span>
                                  <strong>Affidato</strong>
                                </ng-container>

                                <ng-container *ngSwitchCase="2">
                                  <i class="fa-solid fa-truck-arrow-right text-green fs-6 me-2"></i>
                                  <span class="badge badge-green me-2">2</span>
                                  <strong>Ritirato dall’autista</strong>
                                </ng-container>

                                <ng-container *ngSwitchCase="3">
                                  <i class="fa-solid fa-dolly text-green fs-6 me-2"></i>
                                  <span class="badge badge-green me-2">3</span>
                                  <strong>Entrato in magazzino</strong>
                                </ng-container>

                                <ng-container *ngSwitchCase="4">
                                  <i class="fa-solid fa-dolly text-green fs-6 me-2 fa-flip-horizontal"></i>
                                  <span class="badge badge-green me-2">4</span>
                                  <strong>Uscito dal magazzino</strong>
                                </ng-container>

                                <ng-container *ngSwitchCase="5">
                                  <i class="fa-solid fa-warehouse text-green fs-6 me-2"></i>
                                  <span class="badge badge-green me-2">5</span>
                                  <strong>Consegnato</strong>
                                </ng-container>

                                <ng-container *ngSwitchCase="6">
                                  <i class="fa-solid fa-calendar-check text-red fs-6 me-2"></i>
                                  <span class="badge badge-red me-2">6</span>
                                  <strong>Chiuso forzatamente</strong>
                                </ng-container>

                                <ng-container *ngSwitchDefault>
                                  <i class="fa-solid fa-question-circle text-muted fs-6 me-2"></i>
                                  <span class="badge bg-secondary me-2">{{ c.palletComplementaryValueNumber }}</span>
                                  <strong class="text-muted">Stato non definito</strong>
                                </ng-container>
                              </ng-container>
                            </div>

                            <!-- Dati -->
                            <div class="d-flex flex-wrap flex-grow-1 gap-4 small-data">
                              <div class="data-col"><strong>Data</strong><br>
                                {{ c.palletComplementaryValueDate | date: 'dd/MM/yyyy HH:mm' }}
                                <i *ngIf="isDateOutOfOrder(p, i)"
                                   class="fa-solid fa-triangle-exclamation text-orange ms-2 fs-5"
                                   data-bs-toggle="tooltip"
                                   data-bs-placement="top"
                                   title="Lo stato non segue l'ordinamento corretto per la data di inserimento"></i>
                              </div>
                              <div class="data-col"><strong>Inviato</strong><br>
                                <ng-container *ngIf="c.palletComplementaryStatus === 'SENT'; else showStatus">
                                  <i class="fas fa-check" style="color: #259e15;"></i>
                                </ng-container>
                                <ng-template #showStatus>
                                  {{ c.palletComplementaryStatus === 'INSERTED' || c.palletComplementaryStatus === 'CLOSED' || c.palletComplementaryStatus === 'PLANNED' ? '' : c.palletComplementaryStatus }}
                                </ng-template>
                              </div>
                              <div class="data-col"><strong>Magazzino</strong><br>{{ c.warehouseCodeName }}</div>
                              <div class="data-col"><strong>Vettore</strong><br>{{ c.carrierName }}</div>
                            </div>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>

      <!-- Paginazione (stessa barra di shipment-management / images) -->
      <div class="pagination-container" *ngIf="!isLoading && totalCount > 0">
        <div class="pagination-controls">
          <button class="pagination-btn" (click)="onPageChange(1)"
                  [disabled]="currentPage === 1" aria-label="Prima pagina" title="Prima pagina">
            <i class="fas fa-angles-left"></i>
          </button>

          <button class="pagination-btn" (click)="onPageChange(currentPage - 1)"
                  [disabled]="currentPage === 1" aria-label="Precedente" title="Precedente">
            <i class="fas fa-chevron-left"></i>
          </button>

          <div class="page-numbers">
            <ng-container *ngFor="let page of getPageItems(); trackBy: trackByPageItem">
              <span class="pagination-ellipsis" *ngIf="page === null">…</span>
              <button *ngIf="page !== null"
                    class="pagination-number"
                    [class.active]="page === currentPage"
                    (click)="onPageChange(page)"
                    [attr.aria-label]="'Pagina ' + page"
                    [title]="'Vai alla pagina ' + page">
              {{ page }}
            </button>
            </ng-container>
          </div>

          <!-- Vai a pagina: il pulsante si trasforma in un campo per digitare il numero -->
          <div class="page-jump">
            <button class="pagination-btn" *ngIf="!isPageJumpOpen" (click)="openPageJump()"
                    aria-label="Vai a pagina" title="Vai a pagina...">
              <i class="fas fa-hashtag"></i>
            </button>
            <div class="page-jump-field" *ngIf="isPageJumpOpen">
              <input #pageJumpInput type="number" class="page-jump-input" min="1"
                   [max]="getTotalPages()" [value]="pageJumpValue" [placeholder]="' / ' + getTotalPages()"
                   (input)="pageJumpValue = $any($event.target).value"
                   (keydown.enter)="applyPageJump()" (keydown.escape)="closePageJump()" (blur)="closePageJump()">
              <button type="button" class="page-jump-go"
                    (mousedown)="$event.preventDefault()" (click)="applyPageJump()"
                    aria-label="Vai" title="Vai alla pagina">
              <i class="fas fa-level-down-alt fa-rotate-90"></i>
            </button>
            </div>
          </div>


          <span class="pagination-info">
            {{ rangeStart }} - {{ rangeEnd }} di {{ totalCount }}
          </span>
          <!-- Vai all'elemento: porta alla pagina che contiene l'elemento con il numero digitato -->
          <div class="page-jump">
            <button class="pagination-btn" *ngIf="!isItemJumpOpen" (click)="openItemJump()"
                    aria-label="Vai a elemento" title="Vai all'elemento numero...">
              <i class="fas fa-list-ol"></i>
            </button>
            <div class="page-jump-field" *ngIf="isItemJumpOpen">
              <input #itemJumpInput type="number" class="page-jump-input" min="1"
                     [max]="totalCount" [value]="itemJumpValue" [placeholder]="' / ' + totalCount"
                     (input)="itemJumpValue = $any($event.target).value"
                     (keydown.enter)="applyItemJump()" (keydown.escape)="closeItemJump()" (blur)="closeItemJump()">
              <button type="button" class="page-jump-go"
                      (mousedown)="$event.preventDefault()" (click)="applyItemJump()"
                      aria-label="Vai" title="Vai all'elemento">
                <i class="fas fa-level-down-alt fa-rotate-90"></i>
              </button>
            </div>
          </div>

          <button class="pagination-btn" (click)="onPageChange(currentPage + 1)"
                  [disabled]="currentPage === getTotalPages()" aria-label="Successivo" title="Successivo">
            <i class="fas fa-chevron-right"></i>
          </button>

          <button class="pagination-btn" (click)="onPageChange(getTotalPages())"
                  [disabled]="currentPage === getTotalPages()" aria-label="Ultima pagina" title="Ultima pagina">
            <i class="fas fa-angles-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- ===== POPUP: CHIUSURA RESI DA EXCEL ===== -->
<app-close-returns-popup
        [visible]="showCloseReturnsPopup"
        (closed)="closeCloseReturnsPopup()"
        (imported)="onCloseReturnsImported($event)">
</app-close-returns-popup>

<!-- ===== POPUP: CHIUSURA MANUALE RESO (data di consegna) ===== -->
<app-close-manual-popup
        [visible]="showCloseManualPopup"
        [pallets]="closeManualPallets"
        (closed)="closeCloseManualPopup()"
        (palletClosed)="onPalletManuallyClosed($event)"
        (bulkClosed)="onPalletsBulkClosed($event)">
</app-close-manual-popup>

<!-- ===== POPUP: RESI PER VETTORE (intervallo di date + vettori) ===== -->
<app-platform-excel-popup
        [visible]="showPlatformExcelPopup"
        (closed)="closePlatformExcelPopup()"
        (saved)="onPlatformExcelSaved($event)">
</app-platform-excel-popup>

<!-- ===== POPUP: STAMPA RESO (label / bolla) ===== -->
<app-return-print-popup
        [visible]="showReturnPrintPopup"
        [request]="printPopupRequest"
        [relatedPallets]="printPopupPallets"
        [dealer]="printPopupDealer"
        (closed)="closeReturnPrintPopup()">
</app-return-print-popup>

<!-- Bottone copia del dato di cella: compare al passaggio del mouse sulla cella,
     in fondo al dato, solo se la cella ha un valore da copiare.
     Spunta verde di conferma per 1,5s dopo la copia. -->
<ng-template #copyBtn let-p="p" let-col="col">
  <button type="button" class="rt-copy-btn" *ngIf="getCellText(p, col.key)"
          [title]="isCellCopied(p, col.key) ? 'Copiato!' : 'Copia ' + col.label"
          (click)="copyCellValue(p, col.key, $event)">
    <i class="fas" [ngClass]="isCellCopied(p, col.key) ? 'fa-check' : 'fa-copy'"></i>
  </button>
</ng-template>

<!-- Tour Guide Component -->
<app-tour-guide></app-tour-guide>

<!-- Torna in alto: pulsante fisso in basso a destra, visibile solo dopo aver scrollato la pagina -->
<app-scroll-top-button></app-scroll-top-button>

<!-- Loader centrato -->
<div *ngIf="isLoading" class="loading-overlay">
  <div class="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;">
    <span class="visually-hidden">Caricamento...</span>
  </div>
</div>
